var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PixelWrapper',[_c('div',{staticClass:"qon-page"},[_c('div',{staticClass:"qon-wrap"},[_c('nuxt')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }